module.exports = __webpack_public_path__ + "img/game_h-slot_pc_2.a4363feb.jpg";